module.exports = __webpack_public_path__ + "static/media/planing-warning.6197184f.svg";